import { render } from "./WalletIndicatorButton.vue?vue&type=template&id=26091083&scoped=true"
import script from "./WalletIndicatorButton.vue?vue&type=script&lang=js"
export * from "./WalletIndicatorButton.vue?vue&type=script&lang=js"

import "./WalletIndicatorButton.vue?vue&type=style&index=0&id=26091083&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26091083"]])

export default __exports__